<template>
  <ul
    v-if="event"
    class="CreationSteps u-flex"
  >
    <router-link
      v-for="step in eventCreationSteps"
      :key="step.label"
      :class="{
        'current-view': step.label === selected,
        disabled: stepsAreDisabled(step.routeName),
      }"
      :to="{ name: event.type === 'dynamic' ? `${step.routeName}-dynamic-form` : step.routeName, params: { id } }"
    >
      <span
        v-if="getIsComplete(step)"
        class="Icon-s Icon-check-circle"
      />
      {{ step.label }}
    </router-link>
  </ul>
</template>
<script>
export default {
  props: {
    selected: {
      type: String,
      default: null,
    },
    event: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      id: null,
      dynamicFormRoute: '/dynamic/',
      steps: [
        {
          label: 'Basic Info',
          routeName: 'basic-info',
        },
        {
          label: 'Form Builder',
          routeName: 'form-builder',
        },
        {
          label: 'Messages',
          routeName: 'messages',
        },
        {
          label: 'Automations',
          routeName: 'automations',
        },
      ],
    };
  },
  computed: {
    eventCreationSteps() {
      if (this.$route.path.indexOf(this.dynamicFormRoute) !== -1) {
        const steps = [...this.steps];
        steps.splice(2, 0, { label: 'Logic', routeName: 'logic' });
        return steps;
      }
      return this.steps;
    },
  },
  mounted() {
    const { params } = this.$route;
    this.id = params.id;
  },
  methods: {
    stepsAreDisabled(step) {
      switch (step) {
        case 'basic-info':
          return false;
        case 'form-builder':
          return this.event.id === undefined;
        default:
          return this.event.questions.length === 0;
      }
    },
    getIsComplete(step) {
      switch (step.routeName) {
        case 'basic-info':
          return this.event.id !== null;
        case 'form-builder':
          return this.event.questions.length !== 0;
        case 'messages':
          return this.$route.name === 'automations';
        case 'automations':
          return false;
        default:
          return false;
      }
    },
  },
};
</script>
<style scoped lang="less">
.CreationSteps {
  position: absolute;
  top: -40px;
  left: 0;

  @media only screen and (max-width: 1490px) {
    width: 100%;
  }

  a {
    color: grey;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 8px 10px;
    background: rgba(255, 255, 255, 0.54);
    border: 1px solid #eaeaea;

    &.disabled {
      opacity: 0.3;
      pointer-events: none;
    }
    &.current-view {
      color: black;
      background: white;
      border-bottom: none;
      flex-shrink: 0;
    }

    .Icon-check-circle {
      color: #046ff0;
    }

  }
}
</style>
